import React, { useState } from 'react';
import './LanternLabs.css';
import FeatureScrollSection from './FeatureScrollSection';
import NewsSection from './NewsSection';
import FooterSection from './FooterSection';
import PredictBBBDetailPanel from './predictbbb_DetailPanel';
import ZetaDetailPanel from './zeta_DetailPanel';
import LBxAIDetailPanel from './lbxai_DetailPanel';
import ADCDetailPanel from './adc_DetailPanel';
import DrugCombinationDetailPanel from './drugcombination_DetailPanel';
import LanternLabs1 from '../assets/LanternLabs1.png';
import LanternLabs2 from '../assets/LanternLabs2.png';
import LanternLabs2_1 from '../assets/LanternLabs2-1.png';
import LanternLabs3 from '../assets/LanternLabs3.png';
import LanternLabs3_1 from '../assets/LanternLabs3-1.png';
import LanternLabs3copy from '../assets/LanternLabs3copy.png';

const LanternLabs = () => {
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [selectedSection, setSelectedSection] = useState(null);

    const handleOpenPanel = (sectionData) => {
        setSelectedSection(sectionData);
        setIsPanelOpen(true);
        // Prevent scrolling while panel is open
        document.body.style.overflow = 'hidden';
    };

    const handleClosePanel = () => {
        setIsPanelOpen(false);
        // Re-enable scrolling
        document.body.style.overflow = 'auto';
    };

    return (
        <div className="lantern-labs-container">
            {/* Detail Panels for Learn More */}
            <PredictBBBDetailPanel
                isOpen={isPanelOpen && selectedSection?.id === 'predict-bbb'}
                onClose={handleClosePanel}
                sectionData={selectedSection}
            />
            <ZetaDetailPanel
                isOpen={isPanelOpen && selectedSection?.id === 'with-zeta'}
                onClose={handleClosePanel}
                sectionData={selectedSection}
            />
            <LBxAIDetailPanel
                isOpen={isPanelOpen && selectedSection?.id === 'lbx-ai'}
                onClose={handleClosePanel}
                sectionData={selectedSection}
            />
            <ADCDetailPanel
                isOpen={isPanelOpen && selectedSection?.id === 'adc-module'}
                onClose={handleClosePanel}
                sectionData={selectedSection}
            />
            <DrugCombinationDetailPanel
                isOpen={isPanelOpen && (selectedSection?.id === 'drug-combination' || selectedSection?.id === 'combination-ai')}
                onClose={handleClosePanel}
                sectionData={selectedSection}
            />

            {/* Main Content */}
            <main className="main-content">
                {/* Background Text Decoration */}
                <div className="hero-bg-text-container">
                    <div className="hero-bg-text-wrapper">
                        <h1 className="hero-bg-text labs">LABS</h1>
                    </div>
                    <div className="hero-bg-text-wrapper">
                        <h1 className="hero-bg-text lantern">LANTERN</h1>
                    </div>
                </div>

                {/* Background Decorative Image Elements - Moved inside main-content */}
                <img src={LanternLabs1} alt="" id="lantern-bg-1" className="bg-image lantern-labs-img-1" />
                <img src={LanternLabs2} alt="" id="lantern-bg-2" className="bg-image lantern-labs-img-2" />
                <img src={LanternLabs2} alt="" id="lantern-bg-2-2" className="bg-image lantern-labs-img-2-2" />
                <img src={LanternLabs2_1} alt="" id="lantern-bg-2-1" className="bg-image lantern-labs-img-2-1" />
                <img src={LanternLabs3} alt="" id="lantern-bg-3" className="bg-image lantern-labs-img-3" />
                {/* <img src={LanternLabs3_1} alt="" id="lantern-bg-3-1" className="bg-image lantern-labs-img-3-1" /> */}
                <img src={LanternLabs3_1} alt="" id="lantern-bg-3-2" className="bg-image lantern-labs-img-3-2" />
                <img src={LanternLabs3copy} alt="" id="lantern-bg-3-copy" className="bg-image lantern-labs-img-3-copy" />

                <div className="content-wrapper">
                    {/* Title Section */}
                    <div className="title-section">
                        <div className="lantern-text-container">
                            <h1 className="lantern-text">LANTERN</h1>
                        </div>
                        <div className="labs-text-container">
                            <h1 className="labs-text">LABS</h1>
                        </div>
                    </div>

                    {/* Description Section */}
                    <div className="description-section">
                        <div className="tagline-container">
                            <h2 className="tagline">
                                The experimental engine powering innovation inside Lantern Pharma
                            </h2>
                        </div>
                        <div className="description-container">
                            <p className="description">
                                Lantern Labs unites Lantern Pharma’s expertise in AI, oncology, and computational drug development to turn complex biomedical data into scalable AI modules. It’s where we productionize advanced models, accelerate discovery, and evolve RADR®-powering innovations like PredictBBB, withZeta, and LBx-AI to shape the future of cancer therapy.
                            </p>
                        </div>
                    </div>

                    {/* Scroll Down Indicator - Moved inside content-wrapper */}
                    <div className="scroll-down-container" onClick={() => {
                        const nextSection = document.querySelector('.feature-scroll-indicator-target') || document.querySelector('.feature-scroll-container');
                        if (nextSection) {
                            nextSection.scrollIntoView({ behavior: 'smooth' });
                        }
                    }}>
                        <div className="scroll-down-indicator">
                            <div className="mouse">
                                <div className="wheel"></div>
                            </div>
                            <div className="arrow">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* Feature Scroll Section - Next Page Content */}
            <FeatureScrollSection onLearnMore={handleOpenPanel} />

            {/* News Section */}
            <NewsSection />

            {/* Footer / Last Section */}
            <FooterSection />
        </div >
    );
};

export default LanternLabs;
